import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

function Link(props) {
  const {
    classes,
    label,
    link,
    newTab,
    external,
  } = props;

  const target = newTab ? '_blank' : '_self';

  return (
    <a
      className={
        external ? `${classes.root} external` : classes.root
      }
      href={link}
      target={target}
    >
      <span className={classes.linkText}>
        {label}
      </span>
    </a>
  );
}

Link.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  newTab: PropTypes.bool,
  external: PropTypes.bool,
};

Link.defaultProps = {
  newTab: false,
  external: false,
};

export default withStyles(styles)(Link);
